import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const post = (action, data = {}) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  return axios.post(API_URL + action, { auth_key, action, ...data }, { headers: authHeader() });
};

const fetchFilterOptions = () => post("afterlogin/appointmentcampaign/logs/filter-options");

const periodPayload = (values = {}) => {
  const period = values.period ?? values.days ?? "30";
  const payload = { period, days: period };
  if (period === "custom") {
    payload.date_from = values.date_from ?? "";
    payload.date_to = values.date_to ?? "";
  }
  return payload;
};

const filterPayload = (values = {}) => ({
  status: values.status ?? "",
  type: values.type ?? "",
  appointment_campaign_id: values.appointment_campaign_id ?? "",
  is_daily: values.is_daily ?? "",
  is_minutes: values.is_minutes ?? "",
  client_name: values.client_name ?? "",
  client_email: values.client_email ?? "",
  client_phone: values.client_phone ?? "",
});

const fetchAnalytics = (values = {}) =>
  post("afterlogin/appointmentcampaign/logs/analytics", {
    ...periodPayload(values),
    ...filterPayload(values),
  });

const fetchDailySummary = (values = {}) =>
  post("afterlogin/appointmentcampaign/logs/daily-summary", {
    ...periodPayload(values),
    page: values.page ?? 1,
    limit: values.limit ?? 15,
    ...filterPayload(values),
  });

const fetchLogs = (values = {}) =>
  post("afterlogin/appointmentcampaign/logs/list", {
    page: values.page ?? 1,
    limit: values.limit ?? 20,
    date: values.date ?? "",
    ...periodPayload(values),
    ...filterPayload(values),
  });

const resendLog = (logId) =>
  post("afterlogin/appointmentcampaign/logs/resend", {
    log_id: logId,
  });

const AppointmentCampaignSentLogService = {
  fetchFilterOptions,
  fetchAnalytics,
  fetchDailySummary,
  fetchLogs,
  resendLog,
};

export default AppointmentCampaignSentLogService;
